import { Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import Cookies from "js-cookie";
import 'primeicons/primeicons.css'; 
import "./custom.scss";
import Loader from "./components/Loader";
import Login from "./pages/login";
import PrivateRoute from "./utils/PrivateRoute";

const HomePage = lazy(() => import("./pages/home"));
const Products = lazy(() => import("./pages/products"));
const AddProducts = lazy(() => import("./pages/addProducts"));
const CategoriesPage = lazy(() => import("./pages/categoriesPage"));
const SubCategoriesPage = lazy(() => import("./pages/subCategoriesPage"));
const Order = lazy(() => import("./pages/order"));
const Customer = lazy(() => import("./pages/customer"));
const Content = lazy(() => import("./pages/content"));
const Reward = lazy(() => import("./pages/reward"));
const Review = lazy(() => import("./pages/review"));
const ContactListPage = lazy(() => import("./pages/ContactListPage"));
const Ingredients = lazy(() => import("./pages/Ingredients"));
const Setting = lazy(() => import("./pages/setting"));
const ForgotPassword = lazy(() => import("./pages/ForgotPasswordPage"));
const CancleOrder = lazy(() => import("./pages/CancelledOrdersReport"));
const Layout = lazy(() => import("./components/layout/Layout"));
const MediaVideo = lazy(() => import("./pages/mediaVideo"));
const TestimonialPage = lazy(() => import("./pages/testimonial"));
import { ConfirmDialog } from "primereact/confirmdialog";

function App() {
  return (
    <div className="w-full h-full">
        <ConfirmDialog />
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Public route */}
          <Route index element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword/>} />
          {/* Protected routes */}
<Route element={<PrivateRoute />}>
  <Route element={<Layout />}>
    <Route path="dashboard" element={<HomePage />} />
    <Route path="products" element={<Products />} />
    <Route path="add-products" element={<AddProducts />} />
      <Route path="/add-products/:uid" element={<AddProducts />} />
    <Route path="categories" element={<CategoriesPage />} />
        <Route path="subCategories" element={<SubCategoriesPage />} />
    <Route path="order" element={<Order />} />
    <Route path="customer" element={<Customer />} />
    <Route path="content" element={<Content />} />
      <Route path="contactListPage" element={<ContactListPage />} />
    <Route path="reward" element={<Reward />} />
    <Route path="cancelledOrderReport" element={<CancleOrder/>} />
      <Route path="review" element={<Review />} />
    <Route path="ingredients" element={<Ingredients />} />
      <Route path="setting" element={<Setting />} />
     <Route path="mediaVideo" element={<MediaVideo />} />
     <Route path="testimonial" element={<TestimonialPage />} />
  </Route>
</Route>

        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
